var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect } from "react";
import { useConsumers } from "../provider";
import Error from "./error";
import "./styles.css";
var ErrorContainer = function () {
    var _a = useConsumers(), errors = _a.errors, fetchErrors = _a.fetchErrors, deleteAllErrors = _a.deleteAllErrors;
    useEffect(function () {
        fetchErrors();
    }, [fetchErrors]);
    return (_jsxs(_Fragment, { children: [_jsxs("div", __assign({ className: "rjsFEP3fs9_error_container" }, { children: [_jsx("div", __assign({ className: "rjsFEP3fs9_error_header_container" }, { children: _jsx("p", __assign({ className: "rjsFEP3fs9_error_header" }, { children: "Error Log History" })) })), _jsx("div", __assign({ className: "rjsFEP3fs9_clear_all_button_error_container" }, { children: _jsx("button", __assign({ className: errors.length
                                ? "rjsFEP3fs9_clear_all_error_button"
                                : "rjsFEP3fs9_clear_all_error_button_disable", onClick: deleteAllErrors, disabled: !errors.length }, { children: "Clear All" })) }))] })), errors.map(function (error) { return (_jsx(Error, { data: error }, "ERROR-".concat(error.id))); })] }));
};
export default ErrorContainer;
